var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{attrs:{"contents":_vm.contents,"prevRoute":_vm.prevRoute},on:{"close":_vm.close}})}
var staticRenderFns = []

export { render, staticRenderFns }